import { BaseSyntheticEvent, useState } from 'react'
import { Combobox, EInputTypes, ETypeOfNotification, InputPhone, InputTextCustom, PhoneNumber, ResponseDTO, initialStatePhoneNumber, mobilePhoneToString, setNotification, validMobileForInputPhone, useFormValidation } from 'medere-ui-framework'
import { MedereEntityContactDTO, defaultMedereEntityContactDTO } from '../../interface/MedereEntityContactDTO'
import { Button } from 'primereact/button'
import { useIntl } from 'react-intl'
import { AxiosResponse } from 'axios'
import { useDispatch } from 'react-redux'
import { ComboDataDTO } from '../../dto/ComboDataDTO'
import { useContactsService } from '../../servicesHooks/Contacts/useContactsService'
import { useLocationService } from '../../servicesHooks/Location/useLocationService'

interface ContactFormProps{
  closeModal:any,
  contactParam:MedereEntityContactDTO,
  medereentity:number,
  getContactsTypes:any
}


export default function ContactForm({closeModal,contactParam,medereentity,getContactsTypes}:Readonly<ContactFormProps>) {  
    const [contactTypes,setContactTypes] : any = useState(contactParam.contact_types.length>0 ? contactParam.contact_types : null)
    const [contact,setContact]=useState<MedereEntityContactDTO>(contactParam ? contactParam : defaultMedereEntityContactDTO)
    const dispatch = useDispatch();
    const { createContact, updateContact } = useContactsService();
    const { getAllAddressByMedereEntity } = useLocationService();
    const [mobilePhone,setMobilePhone] = useState<PhoneNumber>(contactParam.contactphone ? validMobileForInputPhone(contactParam.contactphone) : initialStatePhoneNumber)
    const intl = useIntl();

    const {errors, setErrors} = useFormValidation(contact);



    function handleSave(){

        // CREAMOS EL DTO PARA ENVIAR 
        let dto = {...contact};
        dto.medereentity = medereentity
        dto.contact_types = contactTypes

        //ES NUEVO
        
        if(contact.medereentity_contact==null || 1>contact.medereentity_contact){
            createContact(dto).then((res:AxiosResponse)=>{
              let data : ResponseDTO = res.data;
              closeModal(true);
              if(data.success){
                dispatch(setNotification({title:'Contacto creado',desc:'',icon:'pi-check-circle',typeOfNotification:ETypeOfNotification.INFO}))
              }else{
                dispatch(setNotification({title:'Error',desc:'No se pudo crear el contacto',icon:'pi-times',typeOfNotification:ETypeOfNotification.WARNING}))
              }
            }).catch((_err: any) => {
              dispatch(setNotification({title:'Error',desc:'No se pudo crear el contacto',icon:'pi-times',typeOfNotification:ETypeOfNotification.WARNING}))
            });
        }else{

          updateContact(dto).then((res:AxiosResponse)=>{
            let data : ResponseDTO = res.data;
            closeModal(true);
            if(data.success){
              dispatch(setNotification({title:'Contacto actualizado',desc:'',icon:'pi-check-circle',typeOfNotification:ETypeOfNotification.INFO}))
            }else{
              dispatch(setNotification({title:'Error',desc:'No se pudo actualizar el contacto',icon:'pi-times',typeOfNotification:ETypeOfNotification.WARNING}))
            }
          }).catch((_err: any) => {
            dispatch(setNotification({title:'Error',desc:'No se pudo actualizar el contacto',icon:'pi-times',typeOfNotification:ETypeOfNotification.WARNING}))
          });
        }
    }

  return (
    <div>
        <Combobox
          optionLabel='name'
          setValue={(e:ComboDataDTO[] | null)=>{
            setContactTypes(e?.length ? e:null)
            setErrors({...errors, contact_types:false})
          }}
          value={contactTypes}
          multiple
          getItems={getContactsTypes}
          floatLabel
          error={errors.contact_types}
          label="Tipo de contacto"
        />
        <InputTextCustom
        error={errors.contactname}
        
        floatLabel label={intl.formatMessage({id:"Name"})} value={contact.contactname} onChange={(e:BaseSyntheticEvent)=>{ 
          setErrors({...errors,contactname:false})
          setContact({...contact,contactname:e.target.value})}}
           inputType={EInputTypes.TEXT}/>
        
        <InputTextCustom
        error={errors.contactlastname}
        
        floatLabel label={intl.formatMessage({id:"Lastname"})} value={contact.contactlastname} onChange={(e:BaseSyntheticEvent)=>{ 
          setErrors({...errors,contactlastname:false})
          setContact({...contact,contactlastname:e.target.value})}}
           inputType={EInputTypes.TEXT}/>
  
        <InputTextCustom floatLabel label="Email"  value={contact.contactemail} onChange={(e:BaseSyntheticEvent)=>{ 
          setContact({...contact,contactemail:e.target.value})}}
          inputType={EInputTypes.TEXT}/>
        <InputPhone 
            error={errors.contactphone}
            floatLabel label="Telefono o Celular"  value={mobilePhone} setValue={(value: PhoneNumber)=>{               
                setMobilePhone(value)
                setContact({...contact,contactphone:mobilePhoneToString(value)})
                setErrors({...errors,contactphone:false})
              }
            }
          />
        <Combobox setValue={(e:ComboDataDTO)=>{
            setContact({...contact, addressdesc: e ? (e.name? e.name : "") : "", address: e ? (e.id? e.id : -1) : -1})
            setErrors({...errors, address: false})
          }} getItems={getAllAddressByMedereEntity} 
          params={{ medereentity }} 
          value={contact.address > 0 ? {id: contact.address, name: contact.addressdesc}:null} 
          optionLabel='name' 
          floatLabel 
          label='Seleccionar Dirección' 
          error={errors.address} 
        />
        <div className='flex flex-row justify-content-end'>
            <Button className="buttonMain2" label="Cancelar" onClick={closeModal}></Button>
            <Button className="buttonMain" label="Guardar" onClick={()=>{
              let _errors = {...errors}        
              if(!contact.address || contact.address <= 0){
                  _errors.address = true
              }

              if(!contactTypes || contactTypes.length <= 0){
                _errors.contact_types = true
              }
              
              handleSave()//handleValidation(handleSave,_errors,["medereentity_contact", "address","contact_types_string","contactemail"])
              
            }}></Button>
        </div>
    </div>
  )
}
